import React from "react";
import { ResponsiveContainer, LineChart, CartesianGrid, XAxis, YAxis, Tooltip, Line } from "recharts";
import dayjs from "dayjs";
import { toNumber } from "../utils/chartTransforms";

const EvolucaoDiariaChart = ({ data = [], height = 300 }) => {
  const series = data.map((d) => ({ ...d, value: toNumber(d.value) }));
  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart data={series}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="data" tickFormatter={(v) => dayjs(v).format("DD/MM")} interval="preserveStartEnd" />
        <YAxis />
        <Tooltip labelFormatter={(v) => dayjs(v).format("DD/MM/YYYY")} formatter={(value) => [`${value} NCEs`, "Quantidade"]} />
        <Line type="monotone" dataKey="value" stroke="#f39c12" strokeWidth={3} dot={{ r: 5 }} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default EvolucaoDiariaChart;
